var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 0C1.196 0 0 1.196 0 2.66667V21.3333C0 22.804 1.196 24 2.66667 24H21.3333C22.804 24 24 22.804 24 21.3333V2.66667C24 1.196 22.804 0 21.3333 0H2.66667ZM2.66667 2.66667H21.3333L21.3359 21.3333H2.66667V2.66667ZM10.6667 5.33333V8H13.3333V5.33333H10.6667ZM10.6667 10.6667V18.6667H13.3333V10.6667H10.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.5cb1a525a8ce1f6cdb118adb08e66b5c.svg";
export { ForwardRef as ReactComponent };